<template>
  <div class="fixed inset-0 bg-gray-900/50 flex items-center justify-center z-50 backdrop-blur-sm">
    <div class="bg-white rounded-xl p-8 shadow-xl text-center max-w-sm mx-4">
      <div class="w-12 h-12 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin mx-auto mb-4"></div>
      <p v-if="message" class="text-gray-700 font-medium">{{ message }}</p>
      <p v-else class="text-gray-700 font-medium">Loading...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
}
</script>





